var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('router-view',{attrs:{"name":"Header"}}),_c('div',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }